import { CheckedComponentInformation } from '@west-australian-newspapers/json-react-layouts'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'
import { GetMainSectionFn } from '../custom-topic-routes'

function getOpinionCollection(
    heading: string,
    topic: string,
): Array<CheckedComponentInformation> {
    return [
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: {
                    initial: 'visible',
                    xs: 'visible',
                    sm: 'visible',
                    md: 'visible',
                },
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading,
                    headingUrl: `/${topic}`,
                },

                dataDefinitionArgs: {
                    type: 'listing',
                    topics: [`${topic}`],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 4,
                    },
                },
            },
        }),
    ]
}

export const getOpinionRouteInfo: GetMainSectionFn = (sectionBuilder) => {
    return [
        ...sectionBuilder.getCuratedSection(),
        ...getOpinionCollection('Editorials', 'opinion/editorials'),
        ...getOpinionCollection('Ben Harvey', 'opinion/ben-harvey'),
        ...billboardLeaderboardMrec('one'),
        ...getOpinionCollection('Justin Langer', 'sport/justin-langer'),
        ...getOpinionCollection('Kim MacDonald', 'opinion/kim-macdonald'),
        ...getOpinionCollection('Paul Murray', 'opinion/paul-murray'),
        ...getOpinionCollection('Laura Newell', 'opinion/laura-newell'),
        ...billboardLeaderboardMrec('two'),
        ...getOpinionCollection("Ben O'Shea", 'opinion/ben-oshea'),
        ...getOpinionCollection('Jessica Page', 'opinion/jessica-page'),
        ...getOpinionCollection('Mark Riley', 'opinion/mark-riley'),
    ]
}
